export default {
    zh: {
        rfpNo: 'RFP Number',
        rfpName: 'RFP Name',
        releaseDate: '发布日期',
        updateDate: '更新时间',
        specUpload: 'Spec上传',
        rfpInitiate: 'Release RFP',
        proposal: '供应商提案',
        recommendation: 'Recommendation',
        publish: 'publish',
        bc: 'BC',
        category1: 'Category1',
        category2: 'Category2',
        description: 'Product Description',
        marketScope: 'Market Scope',
        rfpObjective: 'RFP Objective',
        announce: '发布',
        supplierList: '邀请供应商清单',
        invitationCode: '供应商编号/邀请码',
        supplierName: '供应商名称',
        supplierEnName: '供应商英文名称',
        isSupplier: '是否正式供应商',
        contacts: '联系人',
        email: '邮箱',
        selSupplierTitle: '供应商查询选择',
        plantName: '工厂名称',
        scheduleTitle: 'Schedule of Events',
        projectItem: 'Project Item',
        timeline: 'Timeline',
        remark: 'Remark',
        round: '发布轮次',
        roundEndDate: '轮次结束时间',
        ssrCqs: 'SSR-CQS',
        ssrDetailSS: 'SSR明细-SS',
        ssrDetailSup: 'SSR明细-供应商',
        upAdd: '上方添加行',
        downAdd: '下方添加行',
        baseInfoPane: 'SSR基础信息',
        supplierPane: '供应商Proposal',
        offerInfoPane: '报价信息PQCP',
        costInfoPane: '成本结构',
        productionInfoPane: '产能信息',
        logisticsPane: '物流能力',
        spmCorePane: 'SPM评分',
        stateChangePane: '状态变更日志',
        docDownload: 'Proposal文档下载',
        submitDate: '提交日期',
        summarize: 'Proposal概述',
        downloadAttac: '附件下载',
        offerDownload: '下载本轮次Excel',
        roundsIssue: '轮次发布',
        breakUp : '终止',
        roundsEnd: '轮次结束',
        biding: '应标',
        refuse: '拒绝',
    },
    en: {}
}
